/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ConsultationSortBy {
    CONSULTATION_DATE = 'consultationDate',
    CONSULTATION_TYPE = 'consultationType',
    LEGAL_ENTITY_NAME = 'legalEntityName',
}
